export default __webpack_public_path__ + "static/media/react-router.80ccfe8c.png";